import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from '@/store/store'
import Notifications from 'vue-notification'

import BaseTemplate from '@/layouts/BaseTemplate.vue';
import NewBaseTemplate from '@/layouts/NewBaseTemplate.vue';
import BlankBaseTemplate from '@/layouts/BlankBaseTemplate.vue';
import DashboardBaseTemplate from '@/layouts/DashboardBaseTemplate.vue';
import FooterFiller from '@/components/frontend/FooterFiller.vue';

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(Notifications);

// export default function (Vue, { head, router, isServer }) {
  
// }

Vue.component('BaseTemplate', BaseTemplate)
Vue.component('NewBaseTemplate', NewBaseTemplate)
Vue.component('BlankBaseTemplate', BlankBaseTemplate)
Vue.component('DashboardBaseTemplate', DashboardBaseTemplate)
Vue.component('FooterFiller', FooterFiller)


// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')
async function bootstrap() {
  // this helps to force the front-end to expire its auth before the backend token expires and 
  // starts returning 403 errors with no explaination 
  await store.dispatch("initAuthorizationToken");
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount("#app");
}
bootstrap();